export const SECTION_TITLE = 'BỘ SÁCH "DI SẢN HỒ CHÍ MINH"'

export const SLIDERS = [
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685256118/2022-2023/di-san/DS0_m9mwt4.webp',
        title: '',
        content: ''
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685256118/2022-2023/di-san/DS0_m9mwt4.webp',
        title: '',
        content: ''
    },
]

export const ITEMS = [ 
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255574/2022-2023/di-san/DS1_ktq4h7.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255592/2022-2023/di-san/DS2_jy4yxn.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255593/2022-2023/di-san/DS3_ecjsnf.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255582/2022-2023/di-san/DS4_ywslt5.webp',
        title: '',
        sid: ''
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255585/2022-2023/di-san/DS5_na3qzx.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255581/2022-2023/di-san/DS6_zx7ifd.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255581/2022-2023/di-san/DS7_eaodg2.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255577/2022-2023/di-san/DS8_qymq2f.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255584/2022-2023/di-san/DS9_vho0ob.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255593/2022-2023/di-san/DS10_ye0g37.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255596/2022-2023/di-san/DS11_p0db53.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255576/2022-2023/di-san/DS12_wv9puc.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255574/2022-2023/di-san/DS13_xfycgq.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255586/2022-2023/di-san/DS14_zaxen7.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685255577/2022-2023/di-san/DS15_b9offc.webp',
        title: '',
    },
]